export default __webpack_public_path__ + "static/media/discord.ff388ade.svg";